/** آیکن «گفت‌وگوی سریع» — صاعقه / برق */
export default function QuickChatIcon({ className = "", size = 16, ariaHidden = true }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden={ariaHidden}
    >
      <path
        d="M13.5 2.25a.75.75 0 0 0-1.34-.33L6.1 12.9a.75.75 0 0 0 .67 1.1h4.05l-1.52 8.52a.75.75 0 0 0 1.18.75l9.05-11.82a.75.75 0 0 0-.6-1.18h-4.16l-.33-8.01z"
        fill="currentColor"
      />
    </svg>
  );
}
